import { render, staticRenderFns } from "./Downloadables.vue?vue&type=template&id=321c36c4&scoped=true"
import script from "./Downloadables.vue?vue&type=script&lang=js"
export * from "./Downloadables.vue?vue&type=script&lang=js"
import style0 from "./Downloadables.vue?vue&type=style&index=0&id=321c36c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c36c4",
  null
  
)

export default component.exports